import { ICustomServicePricesByStaff } from 'services/shop/types/api';

const getCustomServicePrice = (
  customServicePricesByStaff: ICustomServicePricesByStaff,
  staffId: string,
  serviceId: string,
  defaultPrice: number,
) => {
  const staffPrices = customServicePricesByStaff?.[staffId];

  const customPrice = staffPrices?.find((item) => item.serviceId === serviceId);

  return customPrice?.price ?? defaultPrice;
};

export default getCustomServicePrice;
